import { create } from 'zustand';
import apiClient from '../api/client';
import Alertas from '../alerts/AlertasGernericos';
import { useProdutosStore } from './ProdutosStore';
import { useVendasStore } from './VendasStore';
import { useTerminaltore } from './TerminaisStores';
import { useCryptoStore } from './CriptoStore';

export const useRelatoriosStore = create((set, get) => ({

    loading: false,
    // VOLTAR AQUI PARA FAZER ISSO 
    BuscarRelatorioDeVendas: async (dados_do_filtro) => {
        try {
            // set({ loading: true })

            console.log("teste de dados", dados_do_filtro);

            const response = await apiClient.post('/GerarRelatorioDeVendas',
                { filtros: dados_do_filtro }
            );

            // const { GetProdutosHanking } = useProdutosStore.getState();
            // const { GetVendas } = useVendasStore.getState();
            // const { GetEstatisticasDosTerminais } = useTerminaltore.getState();
            // const { Cripto } = useCryptoStore.getState();

            // set({ carregando: true, progresso: "Buscando usuário" });

            // const loginResponse = await apiClient.post('/DashboardLogin',
            //     { senha: senha, nome: nome }
            // );

            // const token = loginResponse.data.token;

            // const boas_vindas = loginResponse.data.message

            // // await Cripto(token);

            // localStorage.setItem('tk', token)

            // // apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            // if (!loginResponse) {
            //     throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            // }

            // set({ progresso: "Buscado produtos", nome_do_usuario: nome })

            // await GetProdutosHanking();

            // set({ progresso: "Buscado ultimas vendas" })

            // await GetVendas();

            // set({ progresso: "Buscado terminais" })

            // await GetEstatisticasDosTerminais();

            // Alertas.ExibirAlertaSucesso(`${boas_vindas}`)

            // set({ carregando: false });
            // set({ logado: true });
            // navigate('/Home');

        } catch (err) {
            // set({ carregando: false, progresso: 'Login' });
            // Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        } finally {
            // set({ carregando: false, progresso: 'Login' });
        }
    },


}));
